import { ActionInterface } from "../../../Interface/ActionInterface";
import Constants from "../../../Action/Constants";
import { PropertyInterface } from "../../../Entity/Entities/Property/PropertyInterface";
import Translator from "../../../Translation/Translator";

interface StateInterface {
  byId: any;
  allIds: string[];
};

const initialState: StateInterface = {
  byId: {},
  allIds: [],
};

export const propertiesReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.GLOBAL_PROPERTY_LIST_SUCCESS:
    {
      const byId = {};
      const properties = [...action.payload?.properties];

      properties.forEach((property: PropertyInterface) => {
        byId[property.id] = property;
      });

      const allIds: string[] = Object.keys(byId);

      return {
        ...state,
        byId: {...byId},
        allIds: [...allIds],
      };
    }

    case Constants.PAGE_PROPERTY_CREATE_SUCCESS:
    {
      const byId = !!state.byId[action.payload?.property.id] ? state.byId :
        {
          ...state.byId,
          [action.payload?.property.id]: action.payload?.property
        };

      const allIds: string[] = Object.keys(byId);

      return {
        ...state,
        byId: {...byId},
        allIds: [...allIds],
      };
    }


    case Constants.PAGE_PROPERTY_UPDATE_SUCCESS:
    case Constants.PAGE_PROPERTY_DELETE_SUCCESS:
    case Constants.GLOBAL_ATTACHMENT_PROPERTY_UPLOAD_SUCCESS:
    case Constants.GLOBAL_ATTACHMENT_PROPERTY_DELETE_SUCCESS:
    {
      const currentPropertiesById = {...state.byId};
      delete currentPropertiesById[action.payload?.property.id];
      const byId = {
        [action.payload?.property.id]: action.payload?.property,
        ...currentPropertiesById
      }

      const allIds: string[] = Object.keys(byId);

      return {
        ...state,
        byId: {...byId},
        allIds: [...allIds],
      };
    }

    case Constants.GLOBAL_SET_AVATAR_SUCCESS:
    {
      switch (action.payload?.entity.nameOfEntity.toLowerCase()) {
        case Translator.trans("property").toLowerCase():
        {
          const currentPropertiesById = {...state.byId};
          delete currentPropertiesById[action.payload?.entity.id];
          const byId = {
            [action.payload?.entity.id]: action.payload?.entity,
            ...currentPropertiesById
          }

          const allIds: string[] = Object.keys(byId);

          return {
            ...state,
            byId: {...byId},
            allIds: [...allIds],
          };
        }

        default:
          return {
            ...state
          };
      }
    }

    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
